import { action } from "satcheljs";

export interface AccountAddedFromAccountConfigDialogActionMessage {
    sourceId: string;
    targetWindow: Window | undefined;
    dialogId: string;
}

export const accountAddedFromAccountConfigDialog: (sourceId: string, targetWindow: Window | undefined, dialogId: string) => AccountAddedFromAccountConfigDialogActionMessage = action("accountAddedFromAccountConfigDialog", (sourceId: string, targetWindow: Window | undefined, dialogId: string): AccountAddedFromAccountConfigDialogActionMessage => ({
    sourceId,
    targetWindow,
    dialogId,
}));
